import type { AdsType } from "../types";

export const adsTypeTranslationKeyMap: Record<AdsType, string> = {
    Display: "activation.alerts.cards.badge.display-ads",
    Search: "activation.alerts.cards.badge.search-ads",
    Shopping: "activation.alerts.cards.badge.shopping-ads",
    Social: "activation.alerts.cards.badge.social-ads",
};
